import { OpenReports } from '../ModQueue';

export function Content() {
  return (
    <div data-testid="admin-content">
      <p className="muted">
        Reported comments and screenshots. Removing the target resolves its reports.
      </p>
      <OpenReports base="/api/admin" />
    </div>
  );
}
